import api from './client';

export const getBooks = (params?: any) => api.get('/books', { params });
export const getBook = (id: number) => api.get(`/books/${id}`);
export const createBook = (data: any) => api.post('/books', data);
export const updateBook = (id: number, data: any) => api.put(`/books/${id}`, data);
export const deleteBook = (id: number) => api.delete(`/books/${id}`);
export const getBookCheckouts = (id: number) => api.get(`/books/${id}/checkouts`);
